import { useEffect, useState } from 'react'

/**
 * How long a WebSocket has been unconnected, in ms — `null` while it is
 * connected or disabled. Re-renders once `thresholdMs` has passed, so a caller
 * comparing the result against that threshold (see `planTranscriptTransport`)
 * sees it cross without polling a clock.
 */
export function useSocketDownFor(
	enabled: boolean,
	connected: boolean,
	thresholdMs: number,
): number | null {
	const [downSince, setDownSince] = useState<number | null>(null)
	const [, setTick] = useState(0)

	useEffect(() => {
		if (!enabled || connected) {
			setDownSince(null)
			return
		}
		setDownSince(Date.now())
		const timer = setTimeout(() => setTick((n) => n + 1), thresholdMs)
		return () => clearTimeout(timer)
	}, [enabled, connected, thresholdMs])

	if (!enabled || connected || downSince === null) return null
	return Date.now() - downSince
}
